// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.

// libraries
import Vue from 'vue';
import Raven from 'raven-js';
import RavenVue from 'raven-js/plugins/vue';
import VueAnalytics from 'vue-analytics';
import Meta from 'vue-meta';
import Vuebar from 'vuebar';
import PrettyCheckbox from 'pretty-checkbox-vue';
import VueLocalStorage from 'vue-localstorage';
import { VueMasonryPlugin } from 'vue-masonry';
import 'masonry-layout';
import { sync } from 'vuex-router-sync';

// services
import App from './App';
import router from 'router';
import store from 'store';
import i18n from 'services/i18n';
import Http from 'services/Http';
import Api from 'services/Api';

// components
import 'ui';
import 'views/elements';

// vue-select
import 'vue-select/dist/vue-select.css';

// globals
import notifications from './services/Notifications';
import settings from './config/settings';
import { loadConfig } from './config';

// sentikit-components
import {
  applyPolyfills,
  defineCustomElements,
} from 'sentikit-webcomponents/loader';

// sentikit-components global css
import 'sentikit-webcomponents/dist/sentikit-webcomponents/sentikit-webcomponents.css';

// sentikit-components define web-components
Vue.config.ignoredElements = [/sk-\w*/];
applyPolyfills().then(() => {
  defineCustomElements();
});
//sentikit
import 'sentiance.commons.sentikit/dist/sentiance.commons.sentikit.css';
import 'sentiance.commons.sentikit/dist/assets/fontawesome/css/all.css';

loadConfig().then((Config) => {
  const isProd = process.env.NODE_ENV === 'production';

  const { ENV } = Config;

  if (isProd) {
    Raven.config('https://a00a3582ca53416a944fc9ea7fa1aeea@sentry.io/1187345')
      .addPlugin(RavenVue, Vue)
      .install();
  }

  window.notifications = notifications;
  window.settings = settings;
  window.hideNavbar = !!new URLSearchParams(window.location.search).get(
    'hideNavbar'
  );

  // config
  Vue.config.productionTip = false;
  Vue.config.devtools = true;
  Vue.config.performance = true;

  // initialize plugins
  Vue.use(Meta);
  Vue.use(VueLocalStorage);
  Vue.use(Vuebar);
  Vue.use(PrettyCheckbox);
  Vue.use(VueMasonryPlugin);

  if (ENV === 'u1') {
    Vue.use(VueAnalytics, {
      id: 'UA-58644631-6',
      router,
      debug: {
        enabled: !isProd,
        sendHitTask: isProd,
      },
    });
  }

  // initialize services
  sync(store, router);
  Http.init();
  Vue.prototype.$api = Api;

  /* eslint-disable no-new */
  const app = new Vue({
    el: '#app',
    template: '<App/>',
    components: { App },
    router,
    store,
    i18n,
  });

  // development-only globals
  if (process.env.NODE_ENV === 'development') {
    window.Vue = Vue;
    window.Http = Http;
    window.Api = Api;
    window.$app = app;
    window.$store = store;
  }
});
